module.exports = __webpack_public_path__ + "img/AgeUpIcon1Active_ua.9ecdd871.webp";